module.exports = __webpack_public_path__ + "img/aftereffects.f564cb8a.svg";